<!-- Backdrop — purely decorative; users must use the buttons to dismiss -->
<div
  class="fixed inset-0 z-[60] bg-black/40 transition-opacity duration-150"
  [class.opacity-0]="!visible"
  [class.opacity-100]="visible"
  aria-hidden="true"
></div>

<!-- Dialog -->
<div
  class="fixed left-1/2 top-1/2 z-[61] -translate-x-1/2 -translate-y-1/2 w-full max-w-md bg-white dark:bg-dark-card text-primary dark:text-dark-text rounded-md shadow-lg transition-all duration-150"
  [class.opacity-0]="!visible"
  [class.opacity-100]="visible"
  [class.scale-95]="!visible"
  [class.scale-100]="visible"
  role="alertdialog"
  aria-modal="true"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
>
  <div class="px-6 pt-6 pb-4 flex gap-4">
    <div class="flex-shrink-0 w-10 h-10 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center text-red-600 dark:text-red-400">
      <lucide-icon [name]="AlertTriangle" [size]="20"></lucide-icon>
    </div>
    <div class="flex-grow">
      @if (title) {
        <div class="text-lg font-medium mb-1">{{ title | translate }}</div>
      }
      @if (message) {
        <div class="text-sm text-secondary dark:text-dark-muted">{{ message | translate }}</div>
      }
    </div>
  </div>
  <div class="px-6 py-4 border-t border-t-gray-100 dark:border-t-dark-border flex justify-end gap-2">
    <button appButton type="secondary" (click)="cancel()">
      {{ cancelLabel | translate }}
    </button>
    <button appButton [type]="confirmVariant" (click)="confirm()">
      {{ confirmLabel | translate }}
    </button>
  </div>
</div>
